import React from 'react';
import { NetworkInsights } from '@frontend/gql/social/graphql';
import { Card } from '@frontend/shadcn/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@frontend/shadcn/components/ui/table';
import { InstagramIcon } from '@revfluence/fresh-icons/brands/esm';
import {
  TableHeader as TableHeaderComponent,
  TableHeaderSection,
  TableHeaderLayout,
  TableHeaderLabel,
} from '../table-header';

interface InstagramMetricsCardProps {
  data?: NetworkInsights | null;
}

export const InstagramMetricsCard = ({ data }: InstagramMetricsCardProps) => {
  return (
    <Card aria-label="Instagram Metrics">
      <TableHeaderComponent>
        <TableHeaderLayout>
          <TableHeaderSection>
            <TableHeaderLabel>
              <div className="flex items-center gap-2">
                <InstagramIcon className="h-5 w-5 [&>path]:fill-[url(#instagram-gradient)]" />
                <svg width="0" height="0">
                  <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#833AB4" />
                    <stop offset="50%" stopColor="#FD1D1D" />
                    <stop offset="100%" stopColor="#F77737" />
                  </linearGradient>
                </svg>
                <span aria-live="polite">Instagram</span>
              </div>
            </TableHeaderLabel>
          </TableHeaderSection>
        </TableHeaderLayout>
      </TableHeaderComponent>
      <Table wrapperProps={{ className: 'h-auto' }}>
        <TableHeader>
          <TableRow className="border-t">
            <TableHead className="text-left px-4 py-2 border-r border-t">Metric</TableHead>
            <TableHead className="text-right px-4 py-2 border-t">Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className="text-left border-r">Posts Created</TableCell>
            <TableCell className="text-right">{data?.postsCreated?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left border-r">Potential Reach</TableCell>
            <TableCell className="text-right">{data?.reach?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left border-r">Impression</TableCell>
            <TableCell className="text-right">{data?.impressions?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left border-r">Engagement</TableCell>
            <TableCell className="text-right">{data?.engagements?.toLocaleString() ?? '0'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-left border-r border-b-0">Engagement Rate</TableCell>
            <TableCell className="text-right border-b-0">{data?.engagementRate ? `${(data.engagementRate * 100).toFixed(2)}%` : '0%'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};
